import React, { useState } from 'react';
import { moveSchedule } from '../../../api/adminApi';

/**
 * Moves one or more class rows to another date (all batches in a group session).
 */
const RescheduleControl = ({ scheduleId, scheduleIds, currentDate, onMoved }) => {
  const ids = scheduleIds?.length ? scheduleIds : (scheduleId ? [scheduleId] : []);
  const [open, setOpen] = useState(false);
  const [targetDate, setTargetDate] = useState(currentDate || '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [movedTo, setMovedTo] = useState(null);

  const submit = async () => {
    if (!targetDate || targetDate === currentDate || ids.length === 0) return;
    setBusy(true);
    setError(null);
    try {
      for (const id of ids) {
        await moveSchedule(id, targetDate);
      }
      setMovedTo(targetDate);
      setOpen(false);
      if (onMoved) onMoved({ to: targetDate });
    } catch (moveError) {
      const status = moveError?.response?.status;
      const message = moveError?.response?.data?.message;
      setError(
        status === 409
          ? message || 'An identical class already exists on that date.'
          : message || 'Could not move this class.'
      );
    } finally {
      setBusy(false);
    }
  };

  if (movedTo) {
    return <span className="cal-tl-moved">Moved to {movedTo}</span>;
  }

  if (!open) {
    return (
      <button type="button" className="sb-btn sb-btn-sm" onClick={() => setOpen(true)}>
        Reschedule
      </button>
    );
  }

  return (
    <div className="cal-reschedule">
      <label>
        Move to
        <input
          type="date"
          value={targetDate}
          onChange={(event) => { setTargetDate(event.target.value); setError(null); }}
        />
      </label>
      <button
        type="button"
        className="sb-btn sb-btn-sm sb-btn-primary"
        disabled={busy || !targetDate || targetDate === currentDate}
        onClick={submit}
      >
        {busy ? 'Moving…' : `Move${ids.length > 1 ? ` (${ids.length})` : ''}`}
      </button>
      <button
        type="button"
        className="sb-btn sb-btn-sm"
        disabled={busy}
        onClick={() => { setOpen(false); setError(null); setTargetDate(currentDate || ''); }}
      >
        Cancel
      </button>
      {error && <div className="cal-error">{error}</div>}
    </div>
  );
};

export default RescheduleControl;
